import axios from 'axios';

export class CatalogService {
    /**
     * Función que hace una llamada al back para consultar el catálogo de aforos.
     * @returns {Promise<any>} Respuesta de la petición que regresa la lista
     * de aforos o algún mensaje de error.
     */
    getCatalogAforo() {
        return axios.get('/appapv/getCatalogAforo.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace una llamada al back para consultar el catálogo de instrumentos.
     * @returns {Promise<any>} Respuesta de la petición que regresa la lista
     * de instrumentos o algún mensaje de error.
     */
    getCatalogInstrument() {
        return axios.get('/appapv/getCatalogInstrument.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    getInstitutionCatalog() {
        return axios.get('/appapv/getInstitutionCatalog.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload[0]);
    }

    geSpecialFlowCatalog() {
        return axios.get('/appapv/geSpecialFlowCatalog.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    getRentTypeCatalog() {
        return axios.get('/appapv/getRentTypeCatalog.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    getCatalogValues() {
        return axios.get('/appapv/getCatalogValues.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    getCatalogInstrumentLend() {
        return axios.get('/appapv/getLoanInstrument.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    getCatalogGuarantees() {
        return axios.get('/appapv/getGuaranteeAforo.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);

    }

    /**
     * Función que hace una llamada al back para consultar el catálogo de instrumentos.
     * Con el rol (Prestamista o Prestatario)
     * @returns {Promise<any>} Respuesta de la petición que regresa la lista
     * de instrumentos o algún mensaje de error.
     */
    getCatalogInstitutionByRol(rol) {
        return axios.get('/appapv/getInstitutionByRol.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idRol: rol,
            }
        }).then(res => res.data.payload);
    }

    getCatalogUsers() {
        return axios.get('/appapv/getUsersLog.action', {}).then(res => res.data.payload);
    }
}